const entrypoints: object = window['encoreEntrypoints'] || {};

export function getEntryPaths(entry: string, type: string): Array<string> {
	const entrypoint = entrypoints[entry] || {};

	return entrypoint[type] || [];
}
